import req from "@/assets/js/axios"

export default {
    // 获取首页入驻设计师
    getHotDesigners: (params) => {
        return req.apiAxios('POST', '/designer/designerController/getHotDesigners', params)
    },
    // 条件查询设计师或者用户认证信息
    getFrontDesigners: (params) => {
        return req.apiAxios("POST", "/designer/designerController/getFrontDesigners", params)
    },
    // 更新设计师信息
    updateFrontDesigner: (params) => {
        return req.apiAxios("POST", '/business/designer/BDesignerController/whale-security/updateFrontDesigner', params)
    },
    // 获取设计师的作品
    getOpuses: (params) => {
        return req.apiAxios("POST", '/opus/OpusController/getOpuses', params)
    },
   
    // 上传作品
    createOpus: (params) => {
        return req.apiAxios("POST", '/opus/OpusController/whale-security/createOpus', params)
    },
   
    // 添加作品获奖经历
    createFrontExtend: (params) => {
        return req.apiAxios("POST", '/extend/extendController/whale-security/createFrontExtend', params)
    },
    // 查询作品获奖经历
    getOpusFrontExtends: (params) => {
        return req.apiAxios("POST", '/extend/extendController/getFrontOpusExtends', params)
    },
    // 更新作品获奖经历
    updateFrontExtend: (params) => {
        return req.apiAxios("POST", '/business/extend/BExtendController/whale-security/updateFrontExtend', params)
    },
    //删除获奖经历
    deleteFrontExtend:(params)=>{
        return req.apiAxios("POST",'/business/extend/BExtendController/whale-security/deleteFrontExtend',params)
    },
    // 获取首页品牌商
    getHotBrands: (params) => {
        return req.apiAxios("GET", '/brand/BrandController/getHotBrands', params)
    },
    // 查询品牌商信息
    getBrands: (params) => {
        return req.apiAxios("POST", '/brand/BrandController/getBrands', params)
    },
    // 获取设计师点赞和收藏
    getDesignerCollection: (params) => {
        return req.apiAxios("POST", '/business/designer/BDesignerController/getDesignerCollection', params)
    },
    // 查询用户关注的设计师的作品
    getDynamicOpuses: (params) => {
        return req.apiAxios("POST", '/business/opus/BOpusController/whale-security/getDynamicOpuses', params)
    }
}
